import { useEffect, useState } from "react";
import axios from "axios";
import { Lightbulb, RefreshCw } from "lucide-react";
import { API } from "@/lib/api";

const LABEL = { guna: "Tip guna ATAS", metodologi: "Metodologi HTE" };
const pick = (xs, not) => { const pool = xs.length > 1 ? xs.filter((x) => x.id !== not) : xs; return pool[Math.floor(Math.random() * pool.length)]; };

export const TipBanner = ({ testid = "tip-banner" }) => {
  const [tips, setTips] = useState([]);
  const [tip, setTip] = useState(null);
  useEffect(() => { axios.get(`${API}/tips`).then((r) => { setTips(r.data); setTip(pick(r.data)); }).catch(() => {}); }, []);
  useEffect(() => {
    if (tips.length < 2) return undefined;
    const t = setInterval(() => setTip((c) => pick(tips, c?.id)), 20000);
    return () => clearInterval(t);
  }, [tips]);
  if (!tip) return null;
  return (
    <div className="rounded-2xl border border-line bg-q-soft p-4 flex items-start gap-3" data-testid={testid}>
      <Lightbulb size={18} className="text-q shrink-0 mt-0.5" />
      <div className="flex-1 min-w-0">
        <div className="eyebrow !text-q" data-testid={`${testid}-kategori`}>{LABEL[tip.kategori] || "Tip"}</div>
        <p key={tip.id} className="text-sm text-ink mt-1 leading-relaxed fade-up" data-testid={`${testid}-teks`}>{tip.teks}</p>
      </div>
      {tips.length > 1 && <button onClick={() => setTip(pick(tips, tip.id))} aria-label="Tip lain" data-testid={`${testid}-next`}
        className="h-8 w-8 grid place-items-center rounded-full text-mute hover:text-ink hover:bg-surface shrink-0"><RefreshCw size={14} /></button>}
    </div>
  );
};
